import { useGlobalVariables } from './globalConfig/securedConfigHook';

export const useCreditsLabel = () => {
  const { isSapEnabled } = useGlobalVariables();
  return isSapEnabled ? 'SAP Capacity Unit' : 'Prophecy Credit';
};
